import { useMemo } from "react"
import { MediaContent } from "trunx"

import { Box, Text, Media } from "ui-kit/components-branded/index"
import { Analytics } from "utils/analytics"
import { PsychologistProfile } from "modules/ClientAccount/components/Sessions/PsychologistProfile"
import { NewBookingPageLink } from "app/AppRouter/links"
import { BookingPsy } from "modules/ClientAccount/utils"

interface Props {
    psy: BookingPsy
    isSessionPlanning?: boolean
}

export const SignUpAgainCard = ({ psy, isSessionPlanning = false }: Props) => {
    const handleClickButton = () => {
        Analytics.user_click_on_button_in_sign_up_again_card()
    }

    const handleClickProfileLink = () => {
        Analytics.user_click_on_psy_profile_in_sign_up_again_card()
    }

    const text = useMemo(
        () => ({
            title: isSessionPlanning ? <>Вы&nbsp;планировали сессию</> : "Запишитесь снова",
            subTitle: isSessionPlanning ? (
                <>С этим психологом вы планировали сессию</>
            ) : (
                <>Вот у&nbsp;кого вы&nbsp;были прошлый раз.</>
            ),
        }),
        [isSessionPlanning]
    )

    return (
        <Box>
            <Media>
                <MediaContent>
                    <div className="sign-up-again-card__content">
                        <div className="sign-up-again-card__description">
                            <div className="blm-h3 media__header sign-up-again-card__title">
                                {text.title}
                            </div>
                            <Text>{text.subTitle}</Text>
                        </div>
                        <div className="sign-up-again-card__profile">
                            <PsychologistProfile
                                onClick={handleClickProfileLink}
                                name={psy.name}
                                hashId={psy.hash_id}
                                title={psy.title}
                                publicProfileUrl={psy.public_profile_url}
                                faceUrl={psy.face_url}
                            />
                        </div>
                    </div>
                    <div className="sign-up-again-card__line" />
                    <NewBookingPageLink
                        hashId={psy.hash_id}
                        className="is-primary is-responsive blm-button button"
                        onClick={handleClickButton}
                    >
                        <Text isAccent>Записаться еще раз</Text>
                    </NewBookingPageLink>
                </MediaContent>
            </Media>
        </Box>
    )
}
